import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';

export const EstimatedDeliveryTime = ({ children, estimatedDeliveryTime }) => {
  if (!estimatedDeliveryTime) {
    return children({ normalizedDeliveryTime: null });
  }

  const estimatedDeliveryTimeAsANumber = Number.parseFloat(estimatedDeliveryTime);
  let normalizedDeliveryTime = estimatedDeliveryTime;

  if (estimatedDeliveryTime === `${estimatedDeliveryTimeAsANumber}`) {
    normalizedDeliveryTime = (
      <FormattedMessage
        defaultMessage='{numberOfDays, plural, one {# day} other {# days}}'
        description='estimatedDeliveryTimeService.days'
        id='YuVf8u'
        values={{ numberOfDays: estimatedDeliveryTimeAsANumber }}
      />
    );
  }

  return children({ normalizedDeliveryTime });
};

EstimatedDeliveryTime.propTypes = {
  children: PropTypes.func.isRequired,
  estimatedDeliveryTime: PropTypes.string,
};
